<style scoped>
@import url("https://fonts.googleapis.com/css2?family=Poppins:wght@200&display=swap");

.container {
  min-height: 90vh;
  display: flex;
  /* justify-content: center; */
  align-items: center;
  /* background-color: #eee; */
}
.container .card {
  /* height: 500px; */
  position: relative;
  box-shadow: 0 15px 30px rgba(0, 0, 0, 0.1);
  font-family: "Poppins", sans-serif;
  border-radius: 20px;
}
.container .card .formulaire {
  height: 100%;
}
.container .card .left-side {
  background-color: #304767;
  border-top-left-radius: 20px;
  border-bottom-left-radius: 20px;
  padding: 20px 30px;
  box-sizing: border-box;
}
/*left-side-start*/
.steps-content {
  margin-top: 30px;
  color: #fff;
}
.steps-content p {
  font-size: 12px;
  margin-top: 15px;
}
.progress_bar {
  list-style: none;
  font-size: 13px;
  font-weight: 700;
  counter-reset: container 0;
}
.progress_bar li {
  /* display:flex; */
  list-style: none;
  counter-increment: container 1;
  position: relative;
  margin-right: 133px;
  margin-top: 20px;
}
.progress_bar li::before {
  content: counter(container);
  position: absolute;
  height: 25px;
  width: 25px;
  border-radius: 50%;
  border: 1px solid #eef1f7;
  text-align: center;
  line-height: 26px;
  z-index: 10;
  background-color: #fff;
}

.progress_bar li::after {
  content: "";
  position: absolute;
  height: 2px;
  width: 140px;
  background-color: #f5f7fa;
  top: 12px;
  right: -10px;
}

.progress_bar li.active::after {
  background-color: #f6bc2d !important;
}

.progress_bar li:first-child:after {
  display: none;
}

.progress_bar li.active::before {
  background-color: #f6bc2d;
  border: none;
  color: #fff;
}
.progress_bar li.active {
  color: #fff;
}
.d-none {
  display: none;
}

/*left-side-end*/
.container .card .right-side {
  height: 100%;
  border-radius: 20px;
}
/*right-side-start*/
.main {
  display: none;
  opacity: 0;
  transition: 2s;
}
.active {
  display: block;
  opacity: 1;
  transition: 2s;
}
.main small {
  display: flex;
  justify-content: center;
  align-items: center;
  margin-top: 2px;
  height: 30px;
  width: 30px;
  background-color: #ccc;
  border-radius: 50%;
  color: yellow;
  font-size: 19px;
}
.text {
  margin-top: 20px;
}
.congrats {
  text-align: center;
}
.text p {
  margin-top: 10px;
  font-size: 13px;
  font-weight: 700;
  color: #cbced4;
}

input[type="text"],
input[type="number"],
input[type="email"] {
  width: 100%;
  height: 40px;
  border: none;
  outline: 0;
  border-radius: 5px;
  border: 1px solid #cbced4;
  gap: 20px;
  box-sizing: border-box;
  padding: 0px 10px;
}
select {
  width: 100%;
  height: 40px;
  border: none;
  outline: 0;
  border-radius: 5px;
  border: 1px solid #cbced4;
  gap: 20px;
  box-sizing: border-box;
  padding: 0px 10px;
}
.input-text .input-div span {
  position: absolute;
  top: 10px;
  left: 22px;
  font-size: 14px;
  transition: all 0.5s;
}
.input-div input:focus ~ span,
.input-div input:valid ~ span {
  top: -15px;
  left: 18px;
  font-size: 10px;
  font-weight: 600;
}
/* .buttons button {
  height: 40px;
  width: 100px;
  border: none;
  border-radius: 5px;
  background-color: #0075ff;
  font-size: 12px;
  color: #fff;
  cursor: pointer;
} */
.button_space {
  display: flex;
  gap: 20px;
}
.button_space button:nth-child(1) {
  background-color: #fff;
  color: #000;
  border: 1px solid#000;
}
@keyframes stroke {
  100% {
    stroke-dashoffset: 0;
  }
}
@keyframes scale {
  0%,
  100% {
    transform: none;
  }
  50% {
    transform: scale3d(1.1, 1.1, 1);
  }
}
@keyframes fill {
  100% {
    box-shadow: inset 0px 0px 0px 30px #7ac142;
  }
}

.warning, .invalid {
  border: 1px solid red !important;
  background-color: #ffdddd;
}

.form_color {
  width: 50px;
  height: 40px;
}

/* Mark input boxes that gets an error on validation: */
.invalid {
  background-color: #ffdddd;
}

.form-label {
  font-weight: 600;
  margin-bottom: 5px;
  color: var(--customization_label_color, #333);
  font-family: var(--customization_label_font_family, inherit);
}

.multiselect__tags {
  background-color: transparent !important;
  min-height: 40px !important;
  padding: 8px 40px 0 8px !important;
  outline: 0 !important;
  border: 1px solid #cbced4 !important;
  border-radius: 5px !important;
}

.multiselect__option--selected,
.multiselect__option--highlight,
.multiselect__option--highlight:hover,
.multiselect__content .multiselect__option:hover {
  background-color: #F6BC2D !important;
  color: white !important;
}

.multiselect__select {
  padding: 12px 8px;
}

/* Custom styling for tooltips */
.btn-outline-info {
  border-color: #F6BC2D;
  color: #F6BC2D;
}

.btn-outline-info:hover {
  background-color: #F6BC2D;
  border-color: #F6BC2D;
  color: white;
}

/* Progress bar enhancements */
.progress_bar li {
  cursor: pointer;
  transition: all 0.3s ease;
}

.progress_bar li:hover {
  opacity: 0.8;
}

/* Success animation */
@keyframes pulse {
  0% {
    transform: scale(1);
  }
  50% {
    transform: scale(1.05);
  }
  100% {
    transform: scale(1);
  }
}

.text-success {
  animation: pulse 2s infinite;
}
</style>
<template>
  <div v-if="pages.length > 0" class="m-0"
    :style="{ 
        '--customization_custom_background': customization.custom_background , 
        '--customization_custom_color': customization.custom_color,
        '--customization_font_family': customization.font_family,
        '--customization_label_font_family': customization.label_font_family,
        '--customization_label_color': customization.label_color,
        '--customization_button_border_color': customization.button_border_color,
        '--customization_button_border': customization.button_border,
      }">
    <app-overlay-loader v-if="preloader" />
    
    <div class="container-fluid p-0 d-flex mt-4">
      <div class="col-lg-5 col-md-5 d-none d-md-block">
        <img
          :src="urlGenerator('/images/img.jpg')"
          style="width: 100%; height: 100%; border-radius: 5px"
        />
        <div style="position: absolute; bottom: 10px; padding: 15px; color: white;">
          <p style="font-size: 18px">
            {{ formname }} - Complete your information step by step for a personalized experience.
          </p>
        </div>
      </div>
      
      <div class="col-lg-7 col-md-7">
        <div class="card shadow-md container-fluid m-0">
          <div class="card-header" :style="{ backgroundColor: customization.custom_background, color: customization.custom_color }">
            <h4 class="font-weight-bold">
              {{ formname }}
            </h4>
          </div>
          
          <div class="formulaire">
            <div class="right-side pb-3">
              <!-- Progress Bar -->
              <div class="d-none d-md-block">
                <div style="overflow-x: auto">
                  <ul class="progress_bar d-flex">
                    <li
                      v-for="(page, index) in pages"
                      :key="index"
                      :class="currentTab >= index ? 'active' : ''"
                      @click="showTab(index)"
                      style="cursor: pointer;"
                    >
                      {{ index + 1 }}
                    </li>
                  </ul>
                </div>
              </div>

              <!-- Form Pages -->
              <div
                class="main"
                v-for="(page, index) in pages"
                :key="page.id"
                :class="currentTab === index ? 'active' : ''"
              >
                <div class="text">
                  <h2 class="d-none d-md-block titre">
                    {{ replaceFieldKeysWithValues(page.name) }}
                  </h2>
                  <h4 class="d-block d-md-none">
                    {{ index + 1 }}/{{ pages.length }} {{ replaceFieldKeysWithValues(page.name) }}
                  </h4>
                  <div class="mb-3" v-html="replaceFieldKeysWithValues(page.step_description)"></div>
                </div>

                <div v-if="page.custom_values.length<=0" class="w-100 text-center mt-4 pt-4 mb-4 pb-4">
                  <h3 class="text-center text-warning mt-4 pt-4 mb-4 pb-4">
                    You need to create custom values on this account.
                  </h3>
                </div>

                <div v-else class="input-text row">
                  <div v-for="(custom_value, val_index) in Object.values(page.custom_values)" 
                       :key="custom_value.id" 
                       class="col-lg-6 mb-4">
                    
                    <!--select-->
                    <div v-if="'select' === custom_value_type(custom_value.custom_field_type_id)">
                      <label class="form-label">{{ custom_value.field_name }}</label>
                      <div class="input-group">
                        <select class="form-control" :class="{ required: custom_value.required }"
                          :name="custom_value.field_name" :ref="custom_value.field_name"
                          v-model="field_values[index][val_index].value" @change="setCustomValue(
                            field_values[index][val_index].value,
                            custom_value
                          )" oninput='this.classList.remove("invalid")'>
                          <option disabled :value="''" selected="selected">
                            Please select an option
                          </option>
                          <option v-for="element in custom_value.choices.split(';')" :key="element" :value="element">
                            {{ element }}
                          </option>
                        </select>
                        <div class="input-group-append">
                          <button type="button" class="btn btn-outline-info border-0" data-toggle="tooltip" data-placement="top"
                            :title="custom_value.description ?? custom_value.field_name">
                            <i class="fas fa-info-circle"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                    <!--multi-select-->
                    <div v-if="'multi-select' === custom_value_type(custom_value.custom_field_type_id)">
                      <label class="form-label">{{ custom_value.field_name }}</label>
                      <div class="input-group">
                        <multiselect :name="custom_value.field_name" :ref="custom_value.field_name" :multiple="true"
                          :clear-on-select="false" :preserve-search="true" placeholder="Please select option"
                          v-model="field_values[index][val_index].value" @input="setCustomValue(
                            field_values[index][val_index].value,
                            custom_value
                          )" :preselect-first="false" :close-on-select="false" :options="custom_value.choices.split(';')">
                          <template slot="selection" slot-scope="{ values, search, isOpen }">
                            <span class="multiselect__single" v-if="values.length > 0 && !isOpen">{{ values.length }} options selected</span>
                          </template>
                        </multiselect>
                        <div class="input-group-append">
                          <button type="button" class="btn btn-outline-info border-0" data-toggle="tooltip" data-placement="top"
                            :title="custom_value.description ?? custom_value.field_name">
                            <i class="fas fa-info-circle"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                    <!--text-->
                    <div v-if="['text', 'number', 'password', 'date'].includes(custom_value_type(custom_value.custom_field_type_id))">
                      <label class="form-label">{{ custom_value.field_name }}</label>
                      <div class="input-group">
                        <span class="input-group-prepend" v-if="custom_value.prefix">
                          <span class="input-group-text">{{ custom_value.prefix }}</span>
                        </span>
                        
                        <input v-if="hasOperation(custom_value.fieldKey, custom_value.field_key)" 
                          :type="custom_value_type(custom_value.custom_field_type_id)"
                          class="form-control"
                          :class="{ required: custom_value.required }"
                          :placeholder="custom_value.field_name"
                          :readonly="true"
                          :ref="custom_value.field_name"
                          :name="custom_value.field_name"
                          :value="getFieldOperationValue(
                            operations_values[custom_value.field_key].operand1,
                            operations_values[custom_value.field_key].operand2,
                            operations_values[custom_value.field_key].operator,
                            operations_values[custom_value.field_key].type
                          )"
                          @change="setCustomValue(
                            getFieldOperationValue(
                              operations_values[custom_value.field_key].operand1,
                              operations_values[custom_value.field_key].operand2,
                              operations_values[custom_value.field_key].operator,
                              operations_values[custom_value.field_key].type
                            ),
                            custom_value
                          )"
                          oninput='this.classList.remove("invalid")' />

                        <input v-else
                          :type="custom_value_type(custom_value.custom_field_type_id)"
                          class="form-control"
                          :class="{ required: custom_value.required }"
                          :placeholder="custom_value.field_name"
                          :ref="custom_value.field_name"
                          :name="custom_value.field_name"
                          v-model="field_values[index][val_index].value"
                          @change="setCustomValue(
                            field_values[index][val_index].value,
                            custom_value
                          )"
                          oninput='this.classList.remove("invalid")' />
                        
                        <span class="input-group-append" v-if="custom_value.suffix">
                          <span class="input-group-text">{{ custom_value.suffix }}</span>
                        </span>

                        <div class="input-group-append">
                          <button type="button" class="btn btn-outline-info border-0" data-toggle="tooltip" data-placement="top"
                            :title="custom_value.description ?? custom_value.field_name">
                            <i class="fas fa-info-circle"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                    <!--textarea-->
                    <div v-if="'textarea' == custom_value_type(custom_value.custom_field_type_id)" class="col-12">
                      <label class="form-label">{{ custom_value.field_name }}</label>
                      <div class="input-group">
                        <app-input 
                          v-if="hasOperation(custom_value.fieldKey, custom_value.field_key)" 
                          custom-config
                          type="textarea"
                          class="shadow-sm w-100"
                          :removeClass="true"
                          inputClass="textarea_height"
                          :required="true"
                          :id="'textarea-id' + index + val_index"
                          :label="custom_value.field_name"
                          :class="{ required: custom_value.required }"
                          :name="custom_value.field_name" 
                          :ref="custom_value.field_name"
                          @input="setCustomValue(
                            getFieldOperationValue(
                              operations_values[custom_value.field_key].operand1,
                              operations_values[custom_value.field_key].operand2,
                              operations_values[custom_value.field_key].operator,
                              operations_values[custom_value.field_key].type
                            ),
                            custom_value
                          )" :value="getFieldOperationValue(
                              operations_values[custom_value.field_key].operand1,
                              operations_values[custom_value.field_key].operand2,
                              operations_values[custom_value.field_key].operator,
                              operations_values[custom_value.field_key].type
                            )"
                          oninput='this.classList.remove("invalid")'
                          :placeholder="custom_value.field_name" 
                        />

                        <app-input v-else
                          custom-config
                          type="textarea"
                          class="shadow-sm w-100"
                          :removeClass="true"
                          inputClass="textarea_height"
                          :required="true"
                          :id="'textarea-id' + index + val_index"
                          :key="'text-editor-id' + index + val_index"
                          :label="custom_value.field_name"
                          :class="{ required: custom_value.required }"
                          :name="custom_value.field_name" 
                          :ref="custom_value.field_name"
                          v-model="field_values[index][val_index].value"
                          @input="setCustomValue(
                            field_values[index][val_index].value,
                            custom_value
                          )" 
                          oninput='this.classList.remove("invalid")'
                          :placeholder="custom_value.field_name" 
                        />

                        <div class="input-group-append">
                          <button type="button" class="btn btn-outline-info border-0" data-toggle="tooltip" data-placement="top"
                            :title="custom_value.description ?? custom_value.field_name">
                            <i class="fas fa-info-circle"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                    <!--text editor-->
                    <div v-if="'text-editor' == custom_value_type(custom_value.custom_field_type_id)" class="col-12">
                      <label class="form-label">{{ custom_value.field_name }}</label>
                      <div class="input-group">
                        <app-input 
                          v-if="hasOperation(custom_value.fieldKey, custom_value.field_key)" 
                          custom-config
                          type="text-editor"
                          class="shadow-sm w-100"
                          :required="true"
                          :id="'text-editor-id' + index + val_index"
                          :label="custom_value.field_name"
                          :class="{ required: custom_value.required }"
                          :name="custom_value.field_name" 
                          :ref="custom_value.field_name"
                          @input="setCustomValue(
                            getFieldOperationValue(
                              operations_values[custom_value.field_key].operand1,
                              operations_values[custom_value.field_key].operand2,
                              operations_values[custom_value.field_key].operator,
                              operations_values[custom_value.field_key].type
                            ),
                            custom_value
                          )" :value="getFieldOperationValue(
                              operations_values[custom_value.field_key].operand1,
                              operations_values[custom_value.field_key].operand2,
                              operations_values[custom_value.field_key].operator,
                              operations_values[custom_value.field_key].type
                            )"
                          oninput='this.classList.remove("invalid")'
                          :placeholder="custom_value.field_name" 
                        />

                        <app-input v-else
                          custom-config
                          type="text-editor"
                          class="shadow-sm w-100"
                          :required="true"
                          :id="'text-editor-id' + index + val_index"
                          :key="'text-editor-id' + index + val_index"
                          :label="custom_value.field_name"
                          :class="{ required: custom_value.required }"
                          :name="custom_value.field_name" 
                          :ref="custom_value.field_name"
                          v-model="field_values[index][val_index].value"
                          @input="setCustomValue(
                            field_values[index][val_index].value,
                            custom_value
                          )" 
                          oninput='this.classList.remove("invalid")'
                          :placeholder="custom_value.field_name" 
                        />

                        <div class="input-group-append">
                          <button type="button" class="btn btn-outline-info border-0" data-toggle="tooltip" data-placement="top"
                            :title="custom_value.description ?? custom_value.field_name">
                            <i class="fas fa-info-circle"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                    <!--color picker-->
                    <div v-if="'Color picker' === custom_value_type(custom_value.custom_field_type_id)">
                      <label class="form-label">{{ custom_value.field_name }}</label>
                      <div class="input-group">
                        <div v-if="hasOperation(custom_value.fieldKey, custom_value.field_key)" class="d-flex">
                          <input type="color" class="form-control form_color mr-2" disabled :readonly="true" :ref="custom_value.field_name" :name="custom_value.field_name"
                            @change="setCustomValue(
                              getFieldOperationValue(
                                operations_values[custom_value.field_key].operand1,
                                operations_values[custom_value.field_key].operand2,
                                operations_values[custom_value.field_key].operator,
                                operations_values[custom_value.field_key].type
                              ),
                              custom_value
                            )" :value="getFieldOperationValue(
                              operations_values[custom_value.field_key].operand1,
                              operations_values[custom_value.field_key].operand2,
                              operations_values[custom_value.field_key].operator,
                              operations_values[custom_value.field_key].type
                            )" />
                          <input type="text" disabled class="form-control" :readonly="true" 
                            :ref="custom_value.field_name" :name="custom_value.field_name"
                            @change="setCustomValue(
                              getFieldOperationValue(
                                operations_values[custom_value.field_key].operand1,
                                operations_values[custom_value.field_key].operand2,
                                operations_values[custom_value.field_key].operator,
                                operations_values[custom_value.field_key].type
                              ),
                              custom_value
                            )" :value="getFieldOperationValue(
                              operations_values[custom_value.field_key].operand1,
                              operations_values[custom_value.field_key].operand2,
                              operations_values[custom_value.field_key].operator,
                              operations_values[custom_value.field_key].type
                            )" />
                        </div>

                        <div v-else class="d-flex">
                          <input type="color" class="form-control form_color mr-2" v-model="field_values[index][val_index].value" @input="setCustomValue(
                              field_values[index][val_index].value,
                              custom_value
                            )" />
                          <input type="text" class="form-control" v-model="field_values[index][val_index].value" @input="setCustomValue(
                              field_values[index][val_index].value,
                              custom_value
                            )" />
                        </div>
                        
                        <div class="input-group-append">
                          <button type="button" class="btn btn-outline-info border-0" data-toggle="tooltip" data-placement="top"
                            :title="custom_value.description ?? custom_value.field_name">
                            <i class="fas fa-info-circle"></i>
                          </button>
                        </div>
                      </div>
                    </div>

                    <!--file-->
                    <div v-if="'File' === custom_value_type(custom_value.custom_field_type_id)" class="col-12">
                      <File :custom_value="custom_value" />
                    </div>

                    <!--radio-->
                    <div v-if="'radio' === custom_value_type(custom_value.custom_field_type_id)" class="col-12">
                      <label class="form-label d-block">{{ custom_value.field_name }}</label>
                      <div class="form-check form-check-inline" v-for='(item, item_index) in (custom_value.choices.split(";"))' :key="item_index">
                        <input class="form-check-input" oninput='this.classList.remove("invalid")'
                          :class="{ required: custom_value.required }" :ref="custom_value.field_name"
                          :name="custom_value.field_name" v-model="field_values[index][val_index].value" @change="setCustomValue(
                            field_values[index][val_index].value,
                            custom_value
                          )" type="radio" :id="'inlineRadio' + item_index" :value="item">
                        <label class="form-check-label" :for="'inlineRadio' + item_index"> {{ item }}</label>
                      </div>
                      <button type="button" class="btn btn-sm btn-outline-info ml-2" data-toggle="tooltip" data-placement="top"
                        :title="custom_value.description ?? custom_value.field_name">
                        <i class="fas fa-info-circle"></i>
                      </button>
                    </div>

                    <!--checkbox-->
                    <div v-if="'checkbox' === custom_value_type(custom_value.custom_field_type_id)" class="col-12">
                      <label class="form-label d-block">{{ custom_value.field_name }}</label>
                      <div class="form-check form-check-inline" v-if="custom_value.choices.includes('#single:')">
                        <input class="form-check-input" id="checkbox-1" oninput='this.classList.remove("invalid")'
                          :class="{ required: custom_value.required }" :ref="custom_value.field_name"
                          v-model="field_values[index][val_index].value" @change="setCustomValue(
                            field_values[index][val_index].value,
                            custom_value
                          )" :value="custom_value.choices
                            .replace(/#multiple:|#single:/gi, '')
                            .split(';')[0]
                          " :unchecked-value="custom_value.choices
                            .replace(/#multiple:|#single:/gi, '')
                            .split(';')[1]
                          " type="checkbox">
                        <label class="form-check-label" for="inlineCheckbox1">{{ custom_value.field_name }}</label>
                      </div>

                      <div class="form-check form-check-inline" v-if="custom_value.choices.includes('#multiple:')"
                        v-for='(item, item_index) in custom_value.choices.replace(/#multiple:|#single:/gi, "").split(";")' :key="item">
                        <input class="form-check-input" :id="item" :class="{ required: custom_value.required }"
                         :ref="custom_value.field_name" v-model="field_values[index][val_index].value" @change="setCustomValue(
                            field_values[index][val_index].value,
                            custom_value
                          )" oninput='this.classList.remove("invalid")' type="checkbox" :value="item">
                        <label class="form-check-label" :for="item">{{ item }}</label>
                      </div>

                      <button type="button" class="btn btn-sm btn-outline-info ml-2" data-toggle="tooltip" data-placement="top"
                        :title="custom_value.description ?? custom_value.field_name">
                        <i class="fas fa-info-circle"></i>
                      </button>
                    </div>

                  </div>
                </div>

                <div class="buttons d-flex justify-content-between mt-4">
                  <button
                    class="back_button btn btn-outline-secondary"
                    :disabled="preloader || filePreloader"
                    @click="nextPrev(-1)"
                    v-if="index > 0"
                  >
                    <i class="fa fa-arrow-left" aria-hidden="true"></i>
                    Back
                  </button>
                  <div v-else></div>
                  
                  <button
                    class="next_button btn"
                    :disabled="preloader || filePreloader"
                    @click="nextPrev(1)"
                    :style="'background-color: #F6BC2D; color: white; font-weight: bold'"
                  >
                    <span v-if="index < pages.length - 1">Next Step</span>
                    <span v-else>Complete</span>
                    <i class="fa fa-arrow-right" aria-hidden="true" v-if="index < pages.length - 1"></i>
                    <i class="fa fa-check-circle" aria-hidden="true" v-else></i>
                  </button>
                </div>
              </div>

              <!-- Success Page -->
              <div class="main" v-if="currentTab >= pages.length" :class="currentTab >= pages.length ? 'active' : ''">
                <div class="text-center mt-4">
                  <div class="mb-4">
                    <i class="fas fa-check-circle text-success" style="font-size: 4rem;"></i>
                  </div>
                  <h2 class="text-success">Form Completed Successfully!</h2>
                  <p>Thank you for completing the form. Your information has been saved.</p>
                  <button class="btn" :style="'background-color: #F6BC2D; color: white; font-weight: bold'" @click="resetForm">
                    Start Over
                  </button>
                </div>
              </div>

            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
  
  <div v-else class="w-100 text-center mt-4 pt-4">
    <h3 class="text-center text-warning mt-4 pt-4">
      You need to add pages and custom values to your application.
    </h3>
    <a :href="urlGenerator('app/custom')" type="button" class="btn btn-primary btn-with-shadow mt-4">
      Custom Values
    </a>
  </div>
</template>
<script>
import { urlGenerator } from "../../../Helpers/AxiosHelper";
import Verte from 'verte';
import coreLibrary from "../../../../core/helpers/CoreLibrary";
import 'verte/dist/verte.css';
import Multiselect from "vue-multiselect";
import FirstInput from "./components/FirstInput.vue";
import { FormMixin } from "../../../../core/mixins/form/FormMixin";
import File from "./components/file.vue";

export default {
  mixins: [FormMixin],
  props: [
    "pages",
    "custom_field_types",
    "operations",
    "action",
    "customization",
    "originalCustomValues",
    "formname"
  ],
  components: { 
    Multiselect, 
    verte: Verte, 
    FirstInput, 
    File 
  },

  data() {
    return {
      modalName: "",
      modalDescription: "",
      name: "TextArea",
      next_click: [],
      main_form: [],
      step_list: [],
      num: [],
      formnumber: 0,
      validate_inputs: [],
      validate_textarea: [],
      nb: 5,

      currentTab: 0,

      urlGenerator,
      preloader: false,
      filePreloader: false,
      field_values: [],
      operations_values: [],
      operations_index: [],
      field_index: [],
      page_index: [],
      customValues: [],

      fieldValueMap: new Map(),
      testFieldValueMap: new Map()
    };
  },

  created() {
    this.reorderPage();
    console.log(this.pages);

    this.pages.forEach((page, page_index) => {
      let data = [];
      Object.values(page.custom_values).forEach((custom_value, index) => {
        if (custom_value.choices == null || custom_value.choices == "") {
          if (custom_value.value == null || custom_value.value == "") {
            data.push({ value: custom_value.default_value ?? "" });
            custom_value.value = custom_value.default_value ?? "";
          } else {
            if (
              typeof custom_value.value == "number" ||
              typeof custom_value.value == "string"
            ) {
              data.push({ value: this.removePrefixSuffixValue(custom_value.prefix, custom_value.suffix, custom_value.value ?? "") });
            } else {
              data.push({ value: custom_value.default_value ?? "" });
              custom_value.value = custom_value.default_value ?? "";
            }
          }
        } else {
          if (custom_value.choices.split(";").includes(custom_value.value)) {
            if (
              this.custom_value_type(custom_value.custom_field_type_id) ==
              "checkbox" ||
              this.custom_value_type(custom_value.custom_field_type_id) ==
              "multi-select"
            ) {
              if (custom_value.choices.includes("#single:")) {
                data.push({
                  value: custom_value.value,
                });
              } else {
                data.push({ value: custom_value.value.split(";") });
              }
            } else {
              data.push({ value: custom_value.value });
            }
          } else {
            if (
              this.custom_value_type(custom_value.custom_field_type_id) ==
              "checkbox" ||
              this.custom_value_type(custom_value.custom_field_type_id) ==
              "multi-select"
            ) {
              if (custom_value.choices.includes("#single:")) {
                data.push({
                  value: custom_value.default_value,
                });

                custom_value.value = custom_value.default_value;
              } else {
                if (custom_value.default_value != null) {
                  data.push({ value: custom_value.default_value.split(";") });
                  custom_value.value = custom_value.default_value.split(";");
                } else {
                  data.push({ value: "" });
                  custom_value.value = "";
                }
              }
            } else {
              if (custom_value.default_value != null) {
                data.push({ value: custom_value.default_value });
                custom_value.value = custom_value.default_value;
              } else {
                data.push({ value: "" });
                custom_value.value = "";
              }
            }
          }
        }
        this.field_index[custom_value.fieldKey] = index;
        this.page_index[custom_value.fieldKey] = page_index;
      });
      this.field_values.push(data);
    });

    this.operations.forEach((operation) => {
      this.operations_values[operation.result] = {
        operand1: operation.operand1,
        operand2: operation.operand2,
        operator: operation.operator,
        type: operation.type,
        value: operation.type,
      };
      this.operations_index.push(operation.result);
    });

    this.buildFieldValueMaps();
  },

  mounted() {
    this.next_click = document.querySelectorAll(".next_button");
    this.main_form = document.querySelectorAll(".main");
    this.step_list = document.querySelectorAll(".progress_bar li");
    this.num = document.querySelector(".step-number");
    this.validate_inputs = [...document.querySelectorAll(".main.active input"), ...document.querySelectorAll(".main.active textarea")];

    this.next_click.forEach((next_click_form, index) => {
      if (index == 0) {
        next_click_form.addEventListener("click", () => {
          this.save(true);
        });
      } else {
        next_click_form.addEventListener("click", () => {
          this.save(false);
        });
      }
    });
    var back_click = document.querySelectorAll(".back_button");
    back_click.forEach((back_click_form) => {
      back_click_form.addEventListener("click", this.onBack);
    });
  },

  methods: {
    replaceFieldKeysWithValues(text) {
      if (!text || typeof text !== 'string') return text;
      
      const valueMap = this.action === "test" ? this.testFieldValueMap : this.fieldValueMap;
      
      const pattern = new RegExp(
        Array.from(valueMap.keys())
          .map(key => this.escapeRegExp(key))
          .join('|'),
        'g'
      );

      return text.replace(pattern, match => valueMap.get(match) || '');
    },
    
    escapeRegExp(string) {
        if (!string) return '';
        return string.replace(/[.*+?^${}()|[\]\\]/g, '\\$&');
    },
    
    getPrefixValue(prefix){
      if (prefix && prefix.length > 0) {
        return prefix
      } else {
        return ""
      }
    },

    getSuffixValue(suffix){
      if (suffix && suffix.length > 0) {
        return suffix
      } else {
        return ""
      }
    },

    removePrefixSuffixValue(prefix, suffix, value) {
      if (typeof value !== "string") {
        return value
      }
      if (value.startsWith(prefix) && prefix!=null) {
        value = value.substr(prefix.length);
      }

      if (value.endsWith(suffix) && suffix!=null) {
        value = value.substr(0, value.length - suffix.length);
      }
      return value;
    },

    hasOperation(fieldKey, field_key){
      return this.operations_index.includes(fieldKey) || this.operations_index.includes(field_key);
    },

    buildFieldValueMaps() {
      this.fieldValueMap.clear();
      this.testFieldValueMap.clear();

      if (!this.originalCustomValues) return;

      if (Array.isArray(this.originalCustomValues)) {
        this.originalCustomValues.forEach(field => {
          this.testFieldValueMap.set(field.fieldKey, field.value || '');
        });
      } else if (this.originalCustomValues.customValues) {
        this.originalCustomValues.customValues.forEach(field => {
          this.fieldValueMap.set(field.fieldKey, field.value || '');
        });
      }
    },

    showToolTip(_child) {
      let explanations = document.querySelectorAll(".SpeechBubble");

      let child = document.querySelector(_child);
      var scaleX = child.getBoundingClientRect().width / child.offsetWidth;
      if (scaleX == 0) {
        explanations.forEach(element => {
          element.style.animationName = "shrink";
          element.style.animationDuration = "0.1s";
        });

        child.style.animationName = "expand-bounce";
        child.style.animationDuration = "0.25s";
      } else {
        child.style.animationName = "shrink";
        child.style.animationDuration = "0.1s";
      }
    },

    hideToolTip(_child) {
      let child = document.querySelector(_child);
      child.style.animationName = "shrink";
      child.style.animationDuration = "0.1s";
    },

    ShowToolTip(name, description) {
      this.modalName = name;
      this.modalDescription = description;
      window.dialog.showModal();
    },

    HideToolTip() {
      this.modalName = "";
      this.modalDescription = "";
      window.dialog.close();
    },

    reorderPage() {
      this.pages.sort((a, b) => {
        if (a.position < b.position) {
          return -1;
        }
        if (a.position > b.position) {
          return 1;
        }

        return 0;
      });
    },

    showTab(index) {
      this.currentTab = index;
    },

    resetForm() {
      this.currentTab = 0;
      this.customValues = [];
      // Reset field values to defaults
      this.field_values.forEach((pageValues, pageIndex) => {
        pageValues.forEach((fieldValue, fieldIndex) => {
          fieldValue.value = "";
        });
      });
    },

    nextPrev(n) {
      // This will figure out which tab to display
      if (this.currentTab < this.pages.length || n == -1) {
        // Exit if any field in the current tab is invalid:
        if (n == 1 && !this.validateForm()) return false;
        else if (n == 1 && this.validateForm()) {
          if (this.currentTab == 0) this.customValues = [];

          Object.values(this.pages[this.currentTab].custom_values).forEach(
            (custom_value, val_index) => {
              const operation = this.operations.find(
                ({ result }) => result === custom_value.fieldKey
              );

              if (operation == null) {
                this.customValues.push({
                  id: custom_value.id,
                  name: custom_value.name,
                  value:
                    typeof custom_value.value == "object"
                      ? custom_value.value.join(";")
                      : custom_value.value,
                });
              } else {
                this.customValues.push({
                  id: operation.result,
                  name: this.getOperationName(operation.result),
                  value: this.getOperationValue(operation),
                });
              }
            }
          );

          if (this.pages.length < 2) {
            this.operations.forEach((operation) => {
              const result = this.customValues.find(
                ({ id }) => id === operation.result
              );
              if (result == null) {
                this.customValues.push({
                  id: this.getOperationId(operation.result),
                  name: this.getOperationName(operation.result),
                  value: this.getOperationValue(operation),
                });
              }
            });
          }

          this.$emit("save", this.action, this.customValues, this.currentTab, n, false);
        }
        if (n == -1) {
          // Increase or decrease the current tab by 1:
          this.currentTab = this.currentTab + n;
        } else if (n == 1) {
          this.currentTab = this.currentTab + n;
        }
      }
      // if you have reached the end of the form... :
      else {
        if (n == 1 && !this.validateForm()) return false;

        this.customValues = [];

        Object.values(this.pages[this.currentTab].custom_values).forEach(
          (custom_value, val_index) => {
            const operation = this.operations.find(
              ({ result }) => result === custom_value.fieldKey
            );

            if (operation == null) {
              this.customValues.push({
                id: custom_value.id,
                name: custom_value.name,
                value:
                  typeof custom_value.value == "object"
                    ? custom_value.value.join(";")
                    : custom_value.value,
              });
            } else {
              this.customValues.push({
                id: operation.result,
                name: this.getOperationName(operation.result),
                value: this.getOperationValue(operation),
              });
            }
          }
        );

        this.operations.forEach((operation) => {
          const result = this.customValues.find(
            ({ id }) => id === operation.result
          );
          if (result == null) {
            this.customValues.push({
              id: this.getOperationId(operation.result),
              name: this.getOperationName(operation.result),
              value: this.getOperationValue(operation),
            });
          }
        });

        this.$emit("save", this.action, this.customValues, this.currentTab, n, true);
        return false;
      }
    },

    validateForm() {
      // This deals with validation of the form fields
      var x,
        y,
        i,
        valid = true;
      x = document.getElementsByClassName("main");
      y = x[this.currentTab].getElementsByClassName("required");

      // A loop that checks every input field in the current tab:
      for (i = 0; i < y.length; i++) {
        // If a field is empty...
        if (y[i].value == "") {
          // add an "invalid" class to the field:
          y[i].classList.add("invalid");
          // and set the current valid status to false:
          valid = false;
        }
      }

      return valid; // return the valid status
    },

    onNext() {
      this.formnumber++;
      this.updateform();
      this.progress_forward();
    },
    onBack() {
      this.formnumber--;
      this.updateform();
      this.progress_backward();
    },
    updateform() {
      this.main_form.forEach(function (mainform_number) {
        mainform_number.classList.remove("active");
      });
      this.main_form[this.formnumber].classList.add("active");
    },
    progress_forward() {
      if (this.num) this.num.innerHTML = this.formnumber + 1;
      if (this.step_list[this.formnumber]) this.step_list[this.formnumber].classList.add("active");
    },
    progress_backward() {
      var form_num = this.formnumber + 1;
      if (this.step_list[form_num]) this.step_list[form_num].classList.remove("active");
      if (this.num) this.num.innerHTML = form_num;
    },
    validateform() {
      let validate = true;
      this.validate_inputs = [...document.querySelectorAll(".main.active input"), ...document.querySelectorAll(".main.active select"), ...document.querySelectorAll(".main.active textarea")];
      this.validate_inputs.forEach(function (vaildate_input) {
        vaildate_input.classList?.remove("warning");
        if (vaildate_input.classList.value?.includes("require")) {
          if (vaildate_input.value.length == 0) {
            validate = false;
            vaildate_input.classList?.add("warning");
          }
        }
      });
      return validate;
    },

    compare(a, b) {
      if (a.custom_field_type_id < b.custom_field_type_id) {
        return -1;
      }
      if (a.custom_field_type_id > b.custom_field_type_id) {
        return 1;
      }
      return 0;
    },

    saveFile(file, custom) {
      this.filePreloader = true
      let data = new FormData();
      data.append("file", file);
      data.append("custom_id", custom.id);
      coreLibrary.methods.axiosPost({
        url: "/file/upload",
        data,
      }).then(({ data }) => {
        custom.value = data
        custom.hhh = data
      })
        .catch(({ response }) => {
          if (response.data && response.data.message) {
            this.$toastr.e(response.data.message);
            const errors = Object.values(response.data.data).map((el) => el[0]);
            this.$toastr.e(errors);
          }
        })
        .finally(() => {
          this.filePreloader = false
        });
    },

    reoderCustomValues(customValues) { },

    dataURLtoFile(dataurl, filename) {
      var arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);

      while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
      }

      return new File([u8arr], filename, { type: mime });
    },

    createBase64(event, custom) {
      let file = event.target.files ? event.target.files[0] : null;
      if (file) {
        const reader = new FileReader();
        reader.onload = (event) => {
          custom.value = event.target.result;
          custom.file_name = file.name;
        };
        reader.readAsDataURL(file);
      }
    },

    setCustomValue(value, custom) {
      if (
        this.custom_value_type(custom.custom_field_type_id) == "multi-select" ||
        this.custom_value_type(custom.custom_field_type_id) == "checkbox"
      ) {
        if (custom.choices.includes("#single:")) {
          custom.value = value;
        } else {
          custom.value = value.join(";");
        }
      } else {
        custom.value = this.removePrefixSuffixValue(custom.prefix, custom.suffix, value);
      }
    },

    getFieldOperationValue(operand1, operand2, operator, type) {
      let op2;
      let op1;

      var operand1_without_space = operand1.replace(/\s+/g, "");
      var operand2_without_space = operand2.replace(/\s+/g, "");

      if (this.field_index[operand1] !== undefined) {
        op1 =
          this.field_values[this.page_index[operand1]][
            this.field_index[operand1]
          ].value;
      } 
      else if (this.field_index[operand1_without_space] !== undefined) {
        op1 =
          this.field_values[this.page_index[operand1_without_space]][
            this.field_index[operand1_without_space]
          ].value;
      }
      else {
        op1 = this.findOperationValue(operand1);
      }

      if (this.field_index[operand2] !== undefined) {
        op2 =
          this.field_values[this.page_index[operand2]][
            this.field_index[operand2]
          ].value;
      } 
      else if (this.field_index[operand2_without_space] !== undefined) {
        op2 =
          this.field_values[this.page_index[operand2_without_space]][
            this.field_index[operand2_without_space]
          ].value;
      } 
      else {
        op2 = this.findOperationValue(operand2);
      }

      return this.makeOperation(type, operator, op1, op2);
    },

    makeOperation(type, operator, op1, op2) {
      if (type == "concat") {
        return op1 + "" + op2;
      } else if (type == "math") {
        op1 = parseFloat(op1);
        op2 = parseFloat(op2);

        if (isNaN(op1)) {
          op1 = 0;
        }
        if (isNaN(op2)) {
          op2 = 0;
        }

        if (operator == "addition") {
          return op1 + op2;
        } else if (operator == "substraction") {
          return op1 - op2;
        } else if (operator == "division") {
          return op1 / op2;
        } else if (operator == "multiplication") {
          return op1 * op2;
        }
      }
    },

    next(tab, n) {
      this.showTab(n);
    },

    custom_value_type(id) {
      let type = this.custom_field_types.filter(
        (el) => parseInt(el.id) === parseInt(id)
      );
      return type[0].name;
    },

    getOperationId(op) {
      let result;
      if (this.action == "test") {
        result = this.originalCustomValues.find(({ fieldKey }) => fieldKey === op);
      } else {
        result = this.originalCustomValues.customValues.find(
          ({ fieldKey }) => fieldKey === op
        );
      }
      return result.id;
    },

    getOperationName(op) {
      let result;
      if (this.action == "test") {
        result = this.originalCustomValues.find(({ fieldKey }) => fieldKey === op);
      } else {
        result = this.originalCustomValues.customValues.find(
          ({ fieldKey }) => fieldKey === op
        );
      }
      return result.name;
    },

    getOperationValue(operation) {
      let op1 = this.findOperationValue(operation.operand1);
      let op2 = this.findOperationValue(operation.operand2);

      return this.makeOperation(operation.type, operation.operator, op1, op2);
    },

    findOperationValue(op) {
      if (this.field_index[op] !== undefined) {
        let op1 =
          this.field_values[this.page_index[op]][
            this.field_index[op]
          ].value;
          return op1;
      }

      let value;
      const result = Object.values(this.pages[this.formnumber].custom_values).find(({ fieldKey }) => fieldKey === op);
      let result1;
      if (result == null) {
        if (this.action == "test") {
          result1 = this.originalCustomValues.find(({ fieldKey }) => fieldKey === op);
        } else {
          result1 = this.originalCustomValues.customValues.find(
            ({ fieldKey }) => fieldKey === op
          );
        }
        if (result1 == null) {
          value = op;
        } else {
          value = result1.value??'';
        }
      } else {
        value = result.value??'';
      }
      return value;
    },
  },
};
</script>

<style src="vue-multiselect/dist/vue-multiselect.min.css"></style>
